exports.isatty=function(){return!1};function t(){throw new Error("tty.ReadStream is not implemented")}exports.ReadStream=t;function e(){throw new Error("tty.WriteStream is not implemented")}exports.WriteStream=e;
